<template>
  <div class="we-sidebar-menu">
    <div class="we-sidebar-menu-wrapper">
      <div v-if="title" class="we-sidebar-menu-title">
        <!-- Title -->
        <span>{{ title }}</span>
        <!-- ./Title -->

        <!-- Close Button -->
        <div class="btn btn-sm btn-light" v-on:click="$emit('close')">
          <i class="fas fa-times"></i>
        </div>
        <!-- ./Close Button -->
      </div>
      <hr />

      <!-- Content -->
      <div class="we-sidebar-menu-content custom-scrollbar">
        <slot></slot>
      </div>
      <!-- ./Content -->
    </div>
  </div>
</template>
<script>
export default {
  name: "WeSidebarMenu",
  props: {
    title: {
      default: null,
    },
  },
};
</script>
<style lang="scss">
.we-sidebar {
  &-menu {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: fixed;
    z-index: 999999;
    background-color: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    justify-content: flex-end;
    &-wrapper {
      transition: 400ms all;
      position: relative;
      right: 0;
      width: 300px;
      background-color: #ffffff;
      box-shadow: -5px 3px 10px rgba($color: #000000, $alpha: 0.1);
      border-left: 2px solid rgb(181, 181, 181);
      padding: 20px;
    }
    &-title {
      span {
        font-weight: bold;
      }
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &-content {
      width: 100%;
      max-height: 93%;
      overflow-y: auto;
    }
  }
}
</style>